/*
  Bazaarvoice reviews: show the first 5 reviews, reveal the rest with "See more reviews".
  Only runs when BV renders in light DOM ("Allow CSS overrides" deployed).
  Hiding is done in bv-reviews.css via [data-bvr-collapsed] on the BV host element.
*/
(() => {
  const VISIBLE = 5;
  const HOST_SELECTOR = '[data-bv-show="reviews"]';

  const setup = (host) => {
    if (host.dataset.bvrInit) return;
    host.dataset.bvrInit = 'true';

    // BV still rendering in shadow DOM: our CSS cannot reach it, so do nothing
    if (host.shadowRoot) return;

    const wrap = document.createElement('div');
    wrap.className = 'bvr-more';
    wrap.hidden = true;

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'bvr-more__button';
    button.textContent = 'See more reviews';
    button.setAttribute('aria-expanded', 'false');
    wrap.appendChild(button);
    host.after(wrap);

    host.dataset.bvrCollapsed = 'true';

    const reviews = () => host.querySelectorAll('#reviews_container > section');

    const update = () => {
      const collapsed = host.dataset.bvrCollapsed === 'true';
      wrap.hidden = !collapsed || reviews().length <= VISIBLE;
    };

    button.addEventListener('click', () => {
      delete host.dataset.bvrCollapsed;
      button.setAttribute('aria-expanded', 'true');
      wrap.hidden = true;

      const firstHidden = reviews()[VISIBLE];
      if (firstHidden) {
        firstHidden.setAttribute('tabindex', '-1');
        firstHidden.focus({ preventScroll: true });
      }
    });

    new MutationObserver(update).observe(host, { childList: true, subtree: true });
    update();
  };

  // Wait for bv.js to render: data-bv-ready="true" on the host, or the reviews list appearing
  const isRendered = (host) =>
    host.getAttribute('data-bv-ready') === 'true' || host.querySelector('#reviews_container');

  const watch = (host) => {
    if (isRendered(host)) {
      setup(host);
      return;
    }
    const observer = new MutationObserver(() => {
      if (!isRendered(host)) return;
      observer.disconnect();
      setup(host);
    });
    observer.observe(host, { attributes: true, attributeFilter: ['data-bv-ready'], childList: true, subtree: true });
  };

  const init = () => document.querySelectorAll(HOST_SELECTOR).forEach(watch);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
